// removed by extract-text-webpack-plugin
module.exports = {"form":"_2WTVJdOXfI"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/public/Login/SignUpToken/SignUpToken.module.less
// module id = 478
// module chunks = 3